export const PORTAL_HOTEL_LIST_HEAD_ID = 'portal-hotel-list-head';
export const PORTAL_HOTEL_LIST_ID = 'portal-hotel-list';
